<div
  *ngIf="show"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
>
  <div class="bg-white rounded-2xl p-6 shadow-xl w-full max-w-md">
    <h2 class="text-xl font-bold mb-4">Simulador de Crédito</h2>

    <div class="space-y-4" [formGroup]="form">
      <div>
        <label class="block text-sm font-medium">Valor del Crédito</label>
        <input
          (input)="onDocumentNumberInput($event, 'valorCredito')"
          type="text"
          id="valorCredito"
          name="valorCredito"
          formControlName="valorCredito"
          class="w-full border rounded px-3 py-2"
        />
      </div>
      
      <div>
        <label class="block text-sm font-medium">Plazo (meses)</label>
        <input
          type="number"
          min="1"
          max="24"
          id="plazo"
          name="plazo"
          formControlName="plazo"
          class="w-full border rounded px-3 py-2"
          [class.border-red-500]="form.get('plazo')?.invalid && form.get('plazo')?.touched"
        />
        <div *ngIf="form.get('plazo')?.invalid && form.get('plazo')?.touched" class="text-red-500 text-xs mt-1">
          El plazo debe estar entre 1 y 24 meses.
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium">Interés mensual (%)</label>
        <input
          type="number"
          id="interes"
          name="interes"
          formControlName="interes"
          class="w-full border rounded px-3 py-2"
        />
      </div>

      <div>
        <label class="block text-sm font-medium">Fianza (Opcional)</label>
        <input
          type="number"
          id="fianza"
          name="fianza"
          formControlName="fianza"
          class="w-full border rounded px-3 py-2"
        />
      </div>

      <button
        (click)="calcularCuotas()"
        [disabled]="form.invalid"
        class="bg-blue-600 text-white px-4 py-2 rounded w-full mt-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        Calcular
      </button>

      <div *ngIf="cuotaMensual !== null" class="mt-4 text-sm bg-gray-100 p-3 rounded">
        <p><strong>Cuota Mensual:</strong> ${{ cuotaMensual | number:'1.2-2' }}</p>
        <p><strong>Total a pagar:</strong> ${{ totalPagado | number:'1.2-2' }}</p>
        <p>
          <strong>Importante:</strong>
          Los valores de tu credito pueden variar, segun condiciones del fondeador: fianza (25% max) e interes (Maxímo lo permitido por la SFC).
        </p>
      </div>

      <button
        (click)="cerrar()"
        class="mt-4 text-sm text-red-500 hover:underline w-full"
      >
        Cerrar
      </button>
    </div>
  </div>
</div>
